import React, { createContext, Dispatch, SetStateAction, useState } from 'react';

export interface MediaContext {
  psylarisDetailModal: boolean;
  setPsylarisDetailModal: Dispatch<SetStateAction<boolean>>;
  psylarisDetailInfo: string;
  setPsylarisDetailInfo: Dispatch<SetStateAction<string>>;
  diveIndex: number[];
  setDiveIndex: Dispatch<SetStateAction<number[]>>;
  videos: any;
  setVideos: Dispatch<SetStateAction<any>>;
  detailTitle: string;
  setDetailTitle: Dispatch<SetStateAction<string>>;
  detailPreview: string;
  setDetailPreview: Dispatch<SetStateAction<string>>;
  lastDiveIndex: boolean;
  setLastDiveIndex: Dispatch<SetStateAction<boolean>>;
  selectedItemURL: string;
  setSelectedItemURL: Dispatch<SetStateAction<string>>;
  selectedMarket: string;
  setSelectedMarket: Dispatch<SetStateAction<string>>;
  firstDiveInd: boolean;
  setFirstDiveInd: Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  originalMediaURL: string;
  setOriginalMediaURL: Dispatch<SetStateAction<string>>;
  mediaPopperVideo: boolean;
  setMediaPopperVideo: Dispatch<SetStateAction<boolean>>;
  stereo: string;
  setStereo: Dispatch<SetStateAction<string>>;
  rotation: number;
  setRotation: Dispatch<SetStateAction<number>>;
}

export const MediaContext = createContext<MediaContext>(null!);

interface MediaProviderProps {
  children: any;
}

const MediaProvider: React.FC<MediaProviderProps> = ({ children }) => {
  const [psylarisDetailModal, setPsylarisDetailModal] = useState<boolean>(false);
  const [psylarisDetailInfo, setPsylarisDetailInfo] = useState<string>('');
  const [diveIndex, setDiveIndex] = useState<number[]>([]);
  const [videos, setVideos] = useState<any>([]);
  const [detailTitle, setDetailTitle] = useState<string>('');
  const [detailPreview, setDetailPreview] = useState<string>('');
  const [lastDiveIndex, setLastDiveIndex] = useState<boolean>(false);
  const [selectedItemURL, setSelectedItemURL] = useState<string>('');
  const [selectedMarket, setSelectedMarket] = useState<string>('');
  const [firstDiveInd, setFirstDiveInd] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [originalMediaURL, setOriginalMediaURL] = useState<string>('');
  const [mediaPopperVideo, setMediaPopperVideo] = useState<boolean>(false);
  const [stereo, setStereo] = useState<string>('Off');
  const [rotation, setRotation] = useState<number>(0);

  return (
    <MediaContext.Provider
      value={{
        rotation,
        setRotation,
        stereo,
        setStereo,
        mediaPopperVideo,
        setMediaPopperVideo,
        isLoading,
        setIsLoading,
        firstDiveInd,
        setFirstDiveInd,
        selectedMarket,
        setSelectedMarket,
        selectedItemURL,
        setSelectedItemURL,
        psylarisDetailModal,
        setPsylarisDetailModal,
        psylarisDetailInfo,
        setPsylarisDetailInfo,
        diveIndex,
        setDiveIndex,
        videos,
        setVideos,
        detailTitle,
        setDetailTitle,
        detailPreview,
        setDetailPreview,
        lastDiveIndex,
        setLastDiveIndex,
        originalMediaURL,
        setOriginalMediaURL,
      }}
    >
      {children}
    </MediaContext.Provider>
  );
};

export default MediaProvider;
